import React, { useEffect, useState } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import '../../css/transaction.css';

const PaymentFailed = () => {
  const [searchParams] = useSearchParams();
  const [transactionData, setTransactionData] = useState(null);
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    // First try to get data from server-injected data
    if (window.BEETZEE_TRANSACTION_DATA) {
      const data = window.BEETZEE_TRANSACTION_DATA;
      setTransactionData({
        transactionId: data.transaction_id,
        merchantRef: data.merchant_ref_code,
        amount: data.amount ? parseFloat(data.amount).toFixed(2) : '0.00',
        error: data.error || 'Payment processing failed'
      });
    } else {
      // Fallback to URL parameters
      const transactionId = searchParams.get('transaction_id');
      const merchantRef = searchParams.get('merchant_ref_code');
      const amount = searchParams.get('amount');
      const error = searchParams.get('error');
      
      if (merchantRef && amount) {
        setTransactionData({
          transactionId,
          merchantRef,
          amount: parseFloat(amount).toFixed(2),
          error: error || 'Payment processing failed'
        });
      }
    }

    // Notify parent window about payment failure
    try {
      // Store payment status in localStorage
      localStorage.setItem('paymentStatus', JSON.stringify({
        status: 'failed',
        timestamp: Date.now(),
        transactionData: transactionData,
        error: transactionData?.error || 'Payment processing failed'
      }));

      // Try to communicate with parent window
      if (window.opener) {
        window.opener.postMessage({
          type: 'PAYMENT_FAILED',
          data: transactionData,
          error: transactionData?.error || 'Payment processing failed'
        }, '*');
      }
    } catch (error) {
      console.error('Error communicating payment failure:', error);
    }
  }, [searchParams, transactionData]);

  // Auto-close countdown effect
  useEffect(() => {
    if (countdown > 0) {
      const timer = setTimeout(() => {
        setCountdown(countdown - 1);
      }, 1000);
      return () => clearTimeout(timer);
    } else {
      // Close the window/tab when countdown reaches 0
      window.close();
    }
  }, [countdown]);

  const handleManualClose = () => {
    window.close();
  };

  return (
    <div className="transaction-container">
      <div className="transaction-card failed-card">
        <div className="transaction-icon failed-icon">
          <svg width="80" height="80" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" stroke="#EF4444" strokeWidth="2" fill="#FEF2F2"/>
            <path d="m15 9-6 6" stroke="#EF4444" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="m9 9 6 6" stroke="#EF4444" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        
        <h1 className="transaction-title failed-title">Payment Failed</h1>
        <p className="transaction-message">
          Unfortunately, your payment could not be processed. Please try again or contact support if the issue persists.
        </p>

        {transactionData && (
          <div className="transaction-details">
            {transactionData.transactionId && (
              <div className="detail-row">
                <span className="detail-label">Transaction ID:</span>
                <span className="detail-value">{transactionData.transactionId}</span>
              </div>
            )}
            <div className="detail-row">
              <span className="detail-label">Reference Number:</span>
              <span className="detail-value">{transactionData.merchantRef}</span>
            </div>
            <div className="detail-row">
              <span className="detail-label">Amount:</span>
              <span className="detail-value">₱{transactionData.amount}</span>
            </div>
            <div className="detail-row error-detail">
              <span className="detail-label">Error:</span>
              <span className="detail-value">{transactionData.error}</span>
            </div>
          </div>
        )}

        <div className="countdown-section">
          <div className="countdown-display">
            <p>This window will close automatically in</p>
            <div className="countdown-timer failed-timer">{countdown}</div>
            <p>seconds</p>
          </div>
          <button onClick={handleManualClose} className="btn btn-secondary close-now-btn">
            Close Now
          </button>
        </div>

        <div className="support-info">
          <p className="transaction-note">
            Need help? Contact our support team:
          </p>
          <div className="support-contacts">
            <span>Email: support@hiverooms.com</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentFailed;